import { useState, useEffect } from 'react';
import { supabaseGetter } from '~/api/supabase-getter';

/**
 * Hook to fetch task
 * @returns {Object} Task record, loading state, and error
 */
export const useTask = ({ taskId }) => {
  const [task, setTask] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!taskId) { setTask(null); setLoading(false); setError(null); return }

    async function fetchData() {
      setLoading(true);
      setError(null);

      try {
        const { data: taskData, error: taskError } =
          await supabaseGetter.tasks.getById(taskId);

        if (taskError) throw taskError;

        setTask(taskData || null);
      } catch (err) {
        console.error('Error fetching farm task data:', err);
        setError(err.message);
        setTask(null);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, [taskId]);

  return {
    task,
    loading,
    error,
    invalidate: () => {
      supabaseGetter.tasks.invalidate();
    }
  };
}
